import { render, staticRenderFns } from "./ListItemSettingsLanguage.vue?vue&type=template&id=1bb039b8"
import script from "./ListItemSettingsLanguage.vue?vue&type=script&lang=js"
export * from "./ListItemSettingsLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports